import * as React from 'react';
import TextField from '@mui/material/TextField';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Box from '@mui/material/Box';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment-timezone';
import useShopFormat from 'hooks/useShopFormat';
import { useTranslation } from 'services/localization';

interface Props {
	dateRange: DateRange<string>;
	onDateRangeChange: (dateRange: DateRange<string>) => void;
}

const ValidityDatePicker = (props: Props) => {
	const [from, to] = props.dateRange;
	const { t } = useTranslation();
	const { localFormatString } = useShopFormat();
	const dateFormat = localFormatString('DD.MM.YYYY');

	const value: DateRange<moment.Moment> = [!!from ? moment(from) : null, !!to ? moment(to) : null];
	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DateRangePicker
				startText={t('common:times.from')}
				endText={t('common:times.to')}
				value={value}
				inputFormat={dateFormat}
				onChange={([from, to]) => {
					props.onDateRangeChange([
						from?.startOf('day').toISOString() ?? null,
						to?.endOf('day').toISOString() ?? null,
					]);
				}}
				renderInput={(startProps, endProps) => (
					<React.Fragment>
						<TextField {...startProps} />
						<Box sx={{ mx: 1 }} />
						<TextField {...endProps} />
					</React.Fragment>
				)}
			/>
		</LocalizationProvider>
	);
};

export default ValidityDatePicker;
